// @generated by protoc-gen-es v1.10.0 with parameter "target=ts"
// @generated from file uom/v1/length.proto (package uom.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, protoInt64 } from "@bufbuild/protobuf";

/**
 * @generated from enum uom.v1.UnitLength
 */
export enum UnitLength {
  /**
   * @generated from enum value: UNIT_LENGTH_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * SI base unit
   *
   * @generated from enum value: UNIT_LENGTH_METER = 1;
   */
  METER = 1,

  /**
   * @generated from enum value: UNIT_LENGTH_KILOMETER = 2;
   */
  KILOMETER = 2,

  /**
   * @generated from enum value: UNIT_LENGTH_CENTIMETER = 3;
   */
  CENTIMETER = 3,

  /**
   * @generated from enum value: UNIT_LENGTH_MILE = 4;
   */
  MILE = 4,

  /**
   * @generated from enum value: UNIT_LENGTH_FOOT = 5;
   */
  FOOT = 5,

  /**
   * @generated from enum value: UNIT_LENGTH_INCH = 6;
   */
  INCH = 6,
}
// Retrieve enum metadata with: proto3.getEnumType(UnitLength)
proto3.util.setEnumType(UnitLength, "uom.v1.UnitLength", [
  { no: 0, name: "UNIT_LENGTH_UNSPECIFIED" },
  { no: 1, name: "UNIT_LENGTH_METER" },
  { no: 2, name: "UNIT_LENGTH_KILOMETER" },
  { no: 3, name: "UNIT_LENGTH_CENTIMETER" },
  { no: 4, name: "UNIT_LENGTH_MILE" },
  { no: 5, name: "UNIT_LENGTH_FOOT" },
  { no: 6, name: "UNIT_LENGTH_INCH" },
]);

/**
 * @generated from message uom.v1.LengthInt32
 */
export class LengthInt32 extends Message<LengthInt32> {
  /**
   * @generated from field: uom.v1.UnitLength unit = 1;
   */
  unit = UnitLength.UNSPECIFIED;

  /**
   * @generated from field: int32 value = 2;
   */
  value = 0;

  constructor(data?: PartialMessage<LengthInt32>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "uom.v1.LengthInt32";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "unit", kind: "enum", T: proto3.getEnumType(UnitLength) },
    { no: 2, name: "value", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): LengthInt32 {
    return new LengthInt32().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): LengthInt32 {
    return new LengthInt32().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): LengthInt32 {
    return new LengthInt32().fromJsonString(jsonString, options);
  }

  static equals(a: LengthInt32 | PlainMessage<LengthInt32> | undefined, b: LengthInt32 | PlainMessage<LengthInt32> | undefined): boolean {
    return proto3.util.equals(LengthInt32, a, b);
  }
}

/**
 * @generated from message uom.v1.LengthInt64
 */
export class LengthInt64 extends Message<LengthInt64> {
  /**
   * @generated from field: uom.v1.UnitLength unit = 1;
   */
  unit = UnitLength.UNSPECIFIED;

  /**
   * @generated from field: int64 value = 2;
   */
  value = protoInt64.zero;

  constructor(data?: PartialMessage<LengthInt64>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "uom.v1.LengthInt64";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "unit", kind: "enum", T: proto3.getEnumType(UnitLength) },
    { no: 2, name: "value", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): LengthInt64 {
    return new LengthInt64().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): LengthInt64 {
    return new LengthInt64().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): LengthInt64 {
    return new LengthInt64().fromJsonString(jsonString, options);
  }

  static equals(a: LengthInt64 | PlainMessage<LengthInt64> | undefined, b: LengthInt64 | PlainMessage<LengthInt64> | undefined): boolean {
    return proto3.util.equals(LengthInt64, a, b);
  }
}

/**
 * @generated from message uom.v1.LengthUint32
 */
export class LengthUint32 extends Message<LengthUint32> {
  /**
   * @generated from field: uom.v1.UnitLength unit = 1;
   */
  unit = UnitLength.UNSPECIFIED;

  /**
   * @generated from field: uint32 value = 2;
   */
  value = 0;

  constructor(data?: PartialMessage<LengthUint32>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "uom.v1.LengthUint32";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "unit", kind: "enum", T: proto3.getEnumType(UnitLength) },
    { no: 2, name: "value", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): LengthUint32 {
    return new LengthUint32().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): LengthUint32 {
    return new LengthUint32().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): LengthUint32 {
    return new LengthUint32().fromJsonString(jsonString, options);
  }

  static equals(a: LengthUint32 | PlainMessage<LengthUint32> | undefined, b: LengthUint32 | PlainMessage<LengthUint32> | undefined): boolean {
    return proto3.util.equals(LengthUint32, a, b);
  }
}

/**
 * @generated from message uom.v1.LengthUint64
 */
export class LengthUint64 extends Message<LengthUint64> {
  /**
   * @generated from field: uom.v1.UnitLength unit = 1;
   */
  unit = UnitLength.UNSPECIFIED;

  /**
   * @generated from field: uint64 value = 2;
   */
  value = protoInt64.zero;

  constructor(data?: PartialMessage<LengthUint64>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "uom.v1.LengthUint64";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "unit", kind: "enum", T: proto3.getEnumType(UnitLength) },
    { no: 2, name: "value", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): LengthUint64 {
    return new LengthUint64().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): LengthUint64 {
    return new LengthUint64().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): LengthUint64 {
    return new LengthUint64().fromJsonString(jsonString, options);
  }

  static equals(a: LengthUint64 | PlainMessage<LengthUint64> | undefined, b: LengthUint64 | PlainMessage<LengthUint64> | undefined): boolean {
    return proto3.util.equals(LengthUint64, a, b);
  }
}

/**
 * @generated from message uom.v1.LengthFloat
 */
export class LengthFloat extends Message<LengthFloat> {
  /**
   * @generated from field: uom.v1.UnitLength unit = 1;
   */
  unit = UnitLength.UNSPECIFIED;

  /**
   * @generated from field: float value = 2;
   */
  value = 0;

  constructor(data?: PartialMessage<LengthFloat>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "uom.v1.LengthFloat";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "unit", kind: "enum", T: proto3.getEnumType(UnitLength) },
    { no: 2, name: "value", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): LengthFloat {
    return new LengthFloat().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): LengthFloat {
    return new LengthFloat().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): LengthFloat {
    return new LengthFloat().fromJsonString(jsonString, options);
  }

  static equals(a: LengthFloat | PlainMessage<LengthFloat> | undefined, b: LengthFloat | PlainMessage<LengthFloat> | undefined): boolean {
    return proto3.util.equals(LengthFloat, a, b);
  }
}

/**
 * @generated from message uom.v1.LengthDouble
 */
export class LengthDouble extends Message<LengthDouble> {
  /**
   * @generated from field: uom.v1.UnitLength unit = 1;
   */
  unit = UnitLength.UNSPECIFIED;

  /**
   * @generated from field: double value = 2;
   */
  value = 0;

  constructor(data?: PartialMessage<LengthDouble>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "uom.v1.LengthDouble";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "unit", kind: "enum", T: proto3.getEnumType(UnitLength) },
    { no: 2, name: "value", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): LengthDouble {
    return new LengthDouble().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): LengthDouble {
    return new LengthDouble().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): LengthDouble {
    return new LengthDouble().fromJsonString(jsonString, options);
  }

  static equals(a: LengthDouble | PlainMessage<LengthDouble> | undefined, b: LengthDouble | PlainMessage<LengthDouble> | undefined): boolean {
    return proto3.util.equals(LengthDouble, a, b);
  }
}

/**
 * @generated from message uom.v1.MeterDouble
 */
export class MeterDouble extends Message<MeterDouble> {
  /**
   * @generated from field: double value = 1;
   */
  value = 0;

  constructor(data?: PartialMessage<MeterDouble>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "uom.v1.MeterDouble";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "value", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MeterDouble {
    return new MeterDouble().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MeterDouble {
    return new MeterDouble().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MeterDouble {
    return new MeterDouble().fromJsonString(jsonString, options);
  }

  static equals(a: MeterDouble | PlainMessage<MeterDouble> | undefined, b: MeterDouble | PlainMessage<MeterDouble> | undefined): boolean {
    return proto3.util.equals(MeterDouble, a, b);
  }
}

/**
 * @generated from message uom.v1.KilometerDouble
 */
export class KilometerDouble extends Message<KilometerDouble> {
  /**
   * @generated from field: double value = 1;
   */
  value = 0;

  constructor(data?: PartialMessage<KilometerDouble>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "uom.v1.KilometerDouble";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "value", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): KilometerDouble {
    return new KilometerDouble().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): KilometerDouble {
    return new KilometerDouble().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): KilometerDouble {
    return new KilometerDouble().fromJsonString(jsonString, options);
  }

  static equals(a: KilometerDouble | PlainMessage<KilometerDouble> | undefined, b: KilometerDouble | PlainMessage<KilometerDouble> | undefined): boolean {
    return proto3.util.equals(KilometerDouble, a, b);
  }
}

/**
 * @generated from message uom.v1.CentimeterDouble
 */
export class CentimeterDouble extends Message<CentimeterDouble> {
  /**
   * @generated from field: double value = 1;
   */
  value = 0;

  constructor(data?: PartialMessage<CentimeterDouble>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "uom.v1.CentimeterDouble";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "value", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CentimeterDouble {
    return new CentimeterDouble().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CentimeterDouble {
    return new CentimeterDouble().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CentimeterDouble {
    return new CentimeterDouble().fromJsonString(jsonString, options);
  }

  static equals(a: CentimeterDouble | PlainMessage<CentimeterDouble> | undefined, b: CentimeterDouble | PlainMessage<CentimeterDouble> | undefined): boolean {
    return proto3.util.equals(CentimeterDouble, a, b);
  }
}

/**
 * @generated from message uom.v1.MileDouble
 */
export class MileDouble extends Message<MileDouble> {
  /**
   * @generated from field: double value = 1;
   */
  value = 0;

  constructor(data?: PartialMessage<MileDouble>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "uom.v1.MileDouble";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "value", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MileDouble {
    return new MileDouble().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MileDouble {
    return new MileDouble().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MileDouble {
    return new MileDouble().fromJsonString(jsonString, options);
  }

  static equals(a: MileDouble | PlainMessage<MileDouble> | undefined, b: MileDouble | PlainMessage<MileDouble> | undefined): boolean {
    return proto3.util.equals(MileDouble, a, b);
  }
}

/**
 * @generated from message uom.v1.FootDouble
 */
export class FootDouble extends Message<FootDouble> {
  /**
   * @generated from field: double value = 1;
   */
  value = 0;

  constructor(data?: PartialMessage<FootDouble>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "uom.v1.FootDouble";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "value", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FootDouble {
    return new FootDouble().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FootDouble {
    return new FootDouble().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FootDouble {
    return new FootDouble().fromJsonString(jsonString, options);
  }

  static equals(a: FootDouble | PlainMessage<FootDouble> | undefined, b: FootDouble | PlainMessage<FootDouble> | undefined): boolean {
    return proto3.util.equals(FootDouble, a, b);
  }
}

/**
 * @generated from message uom.v1.InchDouble
 */
export class InchDouble extends Message<InchDouble> {
  /**
   * @generated from field: double value = 1;
   */
  value = 0;

  constructor(data?: PartialMessage<InchDouble>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "uom.v1.InchDouble";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "value", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): InchDouble {
    return new InchDouble().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): InchDouble {
    return new InchDouble().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): InchDouble {
    return new InchDouble().fromJsonString(jsonString, options);
  }

  static equals(a: InchDouble | PlainMessage<InchDouble> | undefined, b: InchDouble | PlainMessage<InchDouble> | undefined): boolean {
    return proto3.util.equals(InchDouble, a, b);
  }
}

